
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'SpinLoader',
  props: {
    size: {
      type: String,
      default: '20px',  // Default size if no prop is provided
    },
    color: {
      type: String,
      default: '#959FA7',  // Default color
    },
  },
})
